"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M19 1H1c-.55 0-1 .45-1 1v16c0 .55.45 1 1 1h18c.55 0 1-.45 1-1V2c0-.55-.45-1-1-1zM7 17H2V8h5v9zm11 0H8V8h10v9zm0-10H2V3h16v4z"];
//# sourceMappingURL=page-layout.js.map